// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3YlxBA73x{margin-top:40px}._32lwBcFKx{margin:0 auto}", "",{"version":3,"sources":["webpack://client/github-app/finishing.scss"],"names":[],"mappings":"AAAA,YACE,eAAA,CAGF,YACE,aAAA","sourcesContent":[".illustration {\n  margin-top: 40px;\n}\n\n.button-container {\n  margin: 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"illustration": "_3YlxBA73x",
	"button-container": "_32lwBcFKx",
	"buttonContainer": "_32lwBcFKx"
};
export default ___CSS_LOADER_EXPORT___;
